import { useLayoutEffect } from "react";

import { useQueryParam } from "~/hooks";
import useNavigate from "~/hooks/useNavigate";

export default function ProductHub() {
  const navigate = useNavigate();
  const paramTrail = useQueryParam("trail");

  useLayoutEffect(() => {
    if (paramTrail.trail) {
      const course = decodeURIComponent(paramTrail.trail);

      navigate(`https://academy${import.meta.env.VITE_APP_DOMAIN}/programs/${course}`, { replace: true });

      return;
    }

    navigate(`https://academy${import.meta.env.VITE_APP_DOMAIN}`, { replace: true });
  }, [navigate, paramTrail]);

  return null;
}
